var shipping = {}; 

var checkCep = function(cthis) {
    shipping.current = $(cthis).closest(".shipping-calculator");
    shipping.cepval = shipping.current.find(".address_zip").val();
    shipping.current.find(".new-get-rates").addClass("get-rates")
    if(shipping.cepval.length != 9) {
        alert("Digite um CEP válido.")
    }else {
        addProdCart();
    }
}
var addProdCart = function() {
    var variantid = $("#variantid");
    if(variantid[0]) {
        var variantvalue = $("#variantid").val();
        var cartItens;

        jQuery.getJSON('/cart.js', function(cart) {
            cartItens = cart.item_count;
            if(cartItens == 0) {
                Shopify.addItem(variantvalue, 1, function(){

                    carregaFrete(shipping.cepval);
                    $('.wrapper-response').html('');

                    function removeItemCart() {
                        if ($('#shipping-rates-feedback')[0] && $('#shipping-rates-feedback').hasClass('success')) {
                            Shopify.removeItem(variantvalue);
                        } else {
                            setTimeout(function () {
                                removeItemCart();
                            }, 1000);
                        }
                    }
                    removeItemCart();
                });
            }else {
                carregaFrete(shipping.cepval);
            } 
        });
    }else {
        carregaFrete(shipping.cepval);
    }
}
var carregaFrete = function() {

    $(".get-rates-custom").addClass("loading");
    $("#shipping-calculator .loading").addClass("load");
    
    $.getJSON("//viacep.com.br/ws/" + shipping.cepval + "/json/?callback=?", function(dados) {
        if (!("erro" in dados)) {
           
            if(!shipping.current.find(".shipping-calculator")[0]) {
                
                shipping.current.find(".wrapper-response").attr("id", "wrapper-response");
                Shopify.Cart.ShippingCalculator.show( {
                    submitButton: "Calcular", 
                    submitButtonDisabled: "Calculando...",
                    moneyFormat: moneyformat
                });
                shipping.current.find(".shipping-calculator").addClass("shiping-loaded");
                /*setTimeout(() => {
                    shipping.current.find(".wrapper-response").removeAttr("id");
                }, 5000);*/
                var state;
                var uf = dados.uf.toUpperCase();
                switch (uf) {
                    case "AC" :	state = "Acre";					break;
                    case "AL" :	state = "Alagoas";				break;
                    case "AM" :	state = "Amazonas";				break;
                    case "AP" :	state = "Amapá";				break;
                    case "BA" :	state = "Bahia";				break;
                    case "CE" :	state = "Ceará";				break;
                    case "DF" :	state = "Distrito Federal";		break;
                    case "ES" :	state = "Espírito Santo";		break;
                    case "GO" :	state = "Goiás";				break;
                    case "MA" :	state = "Maranhão";				break;
                    case "MG" :	state = "Minas Gerais";			break;
                    case "MS" :	state = "Mato Grosso do Sul";	break;
                    case "MT" :	state = "Mato Grosso";			break;
                    case "PA" :	state = "Pará";					break;
                    case "PB" :	state = "Paraíba";				break;
                    case "PE" :	state = "Pernambuco";			break;
                    case "PI" :	state = "Piauí";				break;
                    case "PR" :	state = "Paraná";				break;
                    case "RJ" :	state = "Rio de Janeiro";		break;
                    case "RN" :	state = "Rio Grande do Norte";	break;
                    case "RO" :	state = "Rondônia";				break;
                    case "RR" :	state = "Roraima";				break;
                    case "RS" :	state = "Rio Grande do Sul";	break;
                    case "SC" :	state = "Santa Catarina";		break;
                    case "SE" :	state = "Sergipe";				break;
                    case "SP" :	state = "São Paulo";			break;
                    case "TO" :	state = "Tocantíns";			break;
                  }                  
                  var timerjQuery = setInterval( function() {
                    if($('[name="address[province]"] option', shipping.current)[0]) {
                        $('[name="address[province]"]', shipping.current).val(state); 
                        $('[name="address[province]"]', shipping.current).prop('selected', true);
                        shipping.current.find('.get-rates').trigger('click');
                        clearInterval( timerjQuery ); 
                    }
                  }, 1000);
            }


        } else {
            flag = false;
            alert("CEP não encontrado");
        }
        $(".get-rates-custom").removeClass("loading");
        
    }).fail(function(jqXHR) {
        alert("Consulta de CEP indisponível no momento")
    });    
}
$(function () {
    $(document).on('click', '.get-rates-custom', function() {
        checkCep($(this));
    });

    $(document).on('keypress', '#address_zip', function(event) {
        if(event.keyCode == 13) {
            event.preventDefault();
            checkCep($(this));
        }
    });
});